import React from 'react';

// Cancel/Stop Icon Component
export interface IconProps {
    width?: number;
    height?: number;
    className?: string;
}

export const CancelIcon: React.FC<IconProps> = ({
    width = 18,
    height = 18,
    className = ''
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className={className}
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="9" y1="9" x2="15" y2="15" />
        <line x1="15" y1="9" x2="9" y2="15" />
    </svg>
);

export default CancelIcon;
